import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {BgOpacityContainer} from '@components/common/bg-opacity-container/bg-opacity-container'
import {Loading} from '@components/common/loading/loading'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useSyncEvent} from '@containers/hooks'
import {Header} from './header/header'
import {ShowMore} from './item/show-more'
import {
  StatsTimelineContext,
  StatsTimelineStore,
  useStatsTimelineStore
} from './stats-timeline-store'
import {StatsTimelineTable} from './stats-timeline-table'
import {StatsTimelineTiles} from './stats-timeline-tiles'

const TwCenter = tw.div`
  flex
  justify-center
  text-third-old
  mt-64
`

export const StatsTimeline = observer(() => {
  const [store] = useState(() => new StatsTimelineStore())
  return (
    <StatsTimelineContext.Provider value={store}>
      <StatsTimelineBase />
    </StatsTimelineContext.Provider>
  )
})

const StatsTimelineBase = observer(() => {
  const [state, store] = useStatsTimelineStore()
  useEffect(() => {
    store.updateStats()
  }, [state.itemsToLoad, store.activeFilter])
  useSyncEvent('current', {debounceTime: 2000}, () => {
    store.updateStats()
  })

  return (
    <div className="flex h-full rounded-4">
      <div className="w-full flex flex-col">
        <Header filters={store.profileHub.data.eventFeedFilters} />
        <WithPerfectScrollbar>
          <BgOpacityContainer
            bgOpacityClassName={
              state.view === 'card' ? 'opacity-90' : 'opacity-100'
            }
            bgColorClassName="bg-main-old"
          >
            <div className="px-16 overflow-x-auto">
              <StatsTimelineTable />
              <StatsTimelineTiles />
              <ShowMore />
              {!state.stats && (
                <TwCenter>
                  <Loading />
                </TwCenter>
              )}
              {state.stats && Object.keys(store.events).length === 0 && (
                <TwCenter>{Lang.msg.statsTimeline.empty}</TwCenter>
              )}
            </div>
          </BgOpacityContainer>
        </WithPerfectScrollbar>
      </div>
    </div>
  )
})
